import { useContext, useEffect, useState } from "react";
import { AuthContext } from "context/AuthContext";

import { useNavigate } from "react-router-dom";

import { AzureProfile } from "sso/azure/ui/AzureProfile";
import { useMsal } from "@azure/msal-react";
import { loginRequest } from "sso/azure/authConfig";
import { getAzureToken } from "sso/azure/azure-api";
import { setStorageItem } from "utils/storage";

import Logo from "assets/img/brand.png";

import "./style.scss";

export function Login1002() {
  const navigate = useNavigate();
  const { instance } = useMsal();
  const [loading, setLoading] = useState(false);
  const [invalidUser, setInvalidUser] = useState(false);
  const { loginWithToken, login } = useContext(AuthContext);
  const [useSSO, setUseSSO] = useState(false);

  function loginSSO() {
    setLoading(true);
    setUseSSO(true);
    setInvalidUser(false);
  }

  const startPageBeforeLogin = "/realizations";

  async function handleLoginSSO(response: any) {
    try {
      const password = await getAzureToken();
      const username = response.userPrincipalName;

      if (username && password) {
        await login({ username, password });
      }
    } catch (e) {
      setLoading(false);
      setInvalidUser(true);
      setUseSSO(false);
    }
  }

  useEffect(() => {
    async function doLogin(username: string, password: string) {
      try {
        await login({ username, password });
        navigate("/login");
      } catch (e) {
        setLoading(false);
        setInvalidUser(true);
      }
    }

    async function doLoginWithToken(token: string) {
      try {
        await loginWithToken(token);
        navigate("/login");
      } catch (e) {
        setLoading(false);
        setInvalidUser(true);
      }
    }

    const params = new URLSearchParams(window.location.search);
    const token = params.get("token");
    const agent = params.get("agent");
    const secret = params.get("secret");
    const tokenItem = params.get("tokenItem");

    if (token) {
      setLoading(true);
      doLoginWithToken(token);
    } else if (agent && secret) {
      setLoading(true);
      doLogin(agent, secret);
    } else if (tokenItem) {
      setLoading(true);
      const decodedToken = atob(tokenItem);
      const tokenParts = decodedToken.split(":");
      const id = tokenParts[0];
      const password = tokenParts[1];

      setStorageItem("readOnly", "true");
      doLogin(id, password);
    } else {
      setInvalidUser(true);
    }
  }, [loginWithToken, login, navigate]);

  return (
    <div id="login-wrapper">
      <div className="relative flex items-center w-screen h-screen bg-blue-bg page-login bg-blue-bb">
        <div className="flex flex-col items-center gap-4 px-5 text-center md:items-start md:text-left md:px-0 md:pl-80">
          <img className="block object-cover md:hidden" src={Logo} alt="" />

          <h2 className="font-bold md:text-[45px] text-3xl mb-[18px] font-title text-yellow-bb uppercase">
            Prêmio BB
          </h2>

          <p className="text-white-bb font-medium text-2xl md:text-[28px] md:mb-[30px]">
            Confira as 15 iniciativas excepcionais premiadas!
          </p>

          {loading && !useSSO && !invalidUser && (
            <button className="bg-[#FCF82A] text-[#012D4A] text-base rounded-[4px] px-8 py-4 uppercase font-bold pointer-events-none">
              CARREGANDO...
            </button>
          )}
          {!loading && invalidUser && (
            <button
              className="bg-[#FCF82A] text-[#012D4A] text-base rounded-[4px] px-8 py-4 uppercase font-bold hover:opacity-80 transition-all"
              onClick={() => {
                instance.loginPopup(loginRequest);

                setTimeout(() => {
                  loginSSO();
                }, 200);
              }}
            >
              CLIQUE PARA ENTRAR
            </button>
          )}
          {useSSO ? <AzureProfile onAuthenticate={handleLoginSSO} /> : null}
        </div>

        <div className="relative flex-1 hidden h-screen brand md:block">
          <img
            className="absolute right-0 object-cover"
            src={Logo}
            alt=""
            width={"90%"}
          />
        </div>
      </div>
    </div>
  );
}
